{
  "completed": "Dokončano: ",
  "current": "Trenutno: ",
  "notCompleted": "Ni dokončano: ",
  "steplist": "Seznam korakov"
}
